export default "__VITE_ASSET__BeRphE_j__"